import ListCard from 'components/ListCard'
import { StyledAppContainer } from 'components/Layout/LayoutStyle'
import {
    StyledChatWrapper,
    StyledContainer,
    StyledLeftColumn,
    StyledMainWrapper,
} from 'routes/ChatRouteLayout'
import ListHeader from 'routes/components/ListHeader'

import useSubnet from './useSubnet'
import { Subnet } from 'types/subnetApiService'
import { accountTypeEnum } from 'types/account'
import { useOutlet } from 'react-router-dom'
import ColumnListContentLoader from 'components/ContentLoaders/ColumnListContentLoader'

const Subnets = () => {
    const outlet = useOutlet()
    const {
        subnets,
        handleNavigateSubnet,
        active_subnet_id,
        handleOpenCreateSubnetApi,
        account,
        fetch_subnets_loading,
    } = useSubnet()

    return (
        <StyledAppContainer>
            <StyledContainer>
                <StyledMainWrapper>
                    <StyledLeftColumn>
                        {fetch_subnets_loading ? (
                            <>
                                {Array.from({ length: 20 }).map((_, index) => (
                                    <ColumnListContentLoader key={index} />
                                ))}
                            </>
                        ) : (
                            <>
                                {account?.account_type === accountTypeEnum.Validation ? (
                                    <ListHeader
                                        title={'Subnets'}
                                        onAddClick={handleOpenCreateSubnetApi}
                                    />
                                ) : (
                                    <>
                                        <ListHeader title={'Subnets'} />
                                    </>
                                )}

                                {subnets.map((subnet: Subnet) => {
                                    return (
                                        <ListCard
                                            key={subnet.id}
                                            onClick={() => handleNavigateSubnet(subnet.id)}
                                            name={`${subnet.name}`}
                                            logo={subnet.logo}
                                            picked={active_subnet_id === subnet.id}
                                        />
                                    )
                                })}
                            </>
                        )}
                    </StyledLeftColumn>
                    <StyledChatWrapper>{outlet}</StyledChatWrapper>
                </StyledMainWrapper>

                <div id='right-column-portal-target' />
            </StyledContainer>
        </StyledAppContainer>
    )
}

export default Subnets
